export default "__VITE_ASSET__5yivOF95__"